export function extractPhoneNumbers(input: string): string {
  if (!input) { 
    return null; 
  }

  return input.match(/\d+/g).join('');  
}